import type { SVGProps } from "react";

export function IconBlueMoney(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="6"
        y="19.5"
        width="36"
        height="21"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
      />
      <rect
        x="6"
        y="13.5"
        width="36"
        height="21"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
      />
      <mask
        id="mask0_11429_17673"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="6"
        width="38"
        height="24"
      >
        <rect
          x="6"
          y="7.5"
          width="36"
          height="21"
          fill="#5DD95D"
          stroke="#5DD95D"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_11429_17673)">
        <rect
          x="6"
          y="7.5"
          width="36"
          height="21"
          fill="#63B2FF"
          stroke="#63B2FF"
          strokeWidth="1.5"
        />
        <ellipse
          cx="24"
          cy="18"
          rx="5"
          ry="8"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M12 29.5V29.5C12 25.634 8.86599 22.5 5 22.5V22.5"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M36 6.5V6.5C36 10.366 39.134 13.5 43 13.5V13.5"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M5 13.5V13.5C8.86599 13.5 12 10.366 12 6.5V6.5"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M43 22.5V22.5C39.134 22.5 36 25.634 36 29.5V29.5"
          stroke="black"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
